import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import {
  Dialog,
  DialogContent,
  Typography,
  Grid,
  Button,
  Box,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import CloseIcon from "@mui/icons-material/Close";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "15px",
    background: "#fff",
    overflow: "hidden",
    [theme.breakpoints.up("sm")]: {
      width: "85%",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%",
    },
  },
}));

const HeaderBox = styled(Box)({
  background: "#21c45b",
  padding: "25px 20px 30px",
  textAlign: "center",
  position: "relative",
});

const ContentBox = styled(Box)(({ theme }) => ({
  padding: "20px",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "16px",
  },
}));

const EventDetailsBox = styled(Box)(({ theme }) => ({
  background: "#f7f7f7",
  padding: "16px",
  borderRadius: "10px",
  textAlign: "left",
  margin: "20px 0",
}));

const EventBookingSuccess = ({
  open,
  eventName = "",
  eventLocation = "",
  description = "",
  descriptionIcon = <FileDownloadDoneIcon />,
  handleOnClick,
  buttonContent = "Next",
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <StyledDialog open={open} fullWidth maxWidth="sm">
      <HeaderBox>
        <CheckCircleIcon sx={{ fontSize: "55px", color: "#fff" }} />
        <Typography
          variant="h5"
          fontWeight={700}
          color="white"
          mt={2}
          sx={{ fontSize: isMobile ? "1.2rem" : "1.5rem" }}
        >
          Successful!
        </Typography>
        {/* <Typography
          color="white"
          mt={1}
          sx={{ fontSize: isMobile ? "0.85rem" : "1rem" }}
        >
          Your event registration has been confirmed
        </Typography> */}
        {/* <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 10, right: 10, color: "white" }}
        >
          <CloseIcon />
        </IconButton> */}
      </HeaderBox>

      <DialogContent>
        <ContentBox>
          <EventDetailsBox>
            <Grid container alignItems="center" flexWrap={"nowrap"} spacing={1}>
              {eventLocation ? (
                <Grid item>
                  <LocationOnIcon />
                </Grid>
              ) : (
                ""
              )}
              <Grid item>
                {eventName ? (
                  <Typography variant="subtitle1" fontWeight={600}>
                    {eventName}
                  </Typography>
                ) : (
                  <></>
                )}
                {eventLocation ? (
                  <Typography variant="body2" color="textSecondary">
                    {eventLocation}
                  </Typography>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>

            <Grid
              container
              alignItems="center"
              flexWrap={"nowrap"}
              spacing={1}
              mt={2}
            >
              <Grid item>{descriptionIcon}</Grid>
              <Grid item>
                <Typography variant="body2">{description}</Typography>
              </Grid>
            </Grid>
          </EventDetailsBox>

          <Grid container spacing={2} justifyContent="center">
            {/* <Grid item xs={12} sm="auto">
              <Button
                variant="outlined"
                fullWidth={isMobile}
                sx={{ borderRadius: "8px", minWidth: "100px" }}
                onClick={handleClose}
              >
                Close
              </Button>
            </Grid> */}
            <Grid item xs={12} sm="auto">
              <Button
                variant="contained"
                fullWidth={isMobile}
                sx={{
                  borderRadius: "8px",
                  minWidth: "100px",
                  backgroundColor: "#5249e4",
                  "&:hover": { backgroundColor: "#4138c8" },
                }}
                onClick={handleOnClick}
              >
                {buttonContent}
              </Button>
            </Grid>
          </Grid>
        </ContentBox>
      </DialogContent>
    </StyledDialog>
  );
};

export default EventBookingSuccess;
